import { render, staticRenderFns } from "./ColorView.vue?vue&type=template&id=730b9350&"
import script from "./ColorView.vue?vue&type=script&lang=js&"
export * from "./ColorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ColorView.vue"
export default component.exports